<div class="profile-image-container">
  <img *ngIf="signedURL" class="amplify-s3-image" src="{{ signedURL }}" />
  <img *ngIf="!signedURL && !isDealHRShip" class="profile-photo-image" src="/assets/inthraction_user.png" alt="Default User Image">
  <img *ngIf="!signedURL && isDealHRShip" class="profile-photo-image" src="/assets/dealhrship_user.png" alt="Default User Image">
</div>
